var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',{key:_vm.header},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('router-link',{key:_vm.linkText,staticClass:"secondary text-decoration-none clickable",attrs:{"to":_vm.routerLink}},[_c('v-icon',{staticClass:"translate-left-25"},[_vm._v("mdi-chevron-left")]),_vm._v(_vm._s(_vm.linkText)+" ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }